import {
    IAuthenticationFlow,
    IAuthenticationFlowRunner,
    ILoginOptions,
    IAuthenticationStorage,
} from '../models';
import { CrossAuthenticationFlow } from '../flows/cross-authentication-flow';
import { loadAuthenticationStorage } from '../utils/authentication.storage.loader';
import { MigrationAuthenticationFlow } from '../flows/migration-authentication-flow';

export class CrossAuthenticationFlowRunner implements IAuthenticationFlowRunner {
    private _authenticationStorage: IAuthenticationStorage;

    constructor() {}

    public execute = async (options?: ILoginOptions): Promise<void> => {
        this._authenticationStorage = await loadAuthenticationStorage();
        if (options) {
            this._authenticationStorage.setLoginOptions(options);
        }
        const listOfFlows: Array<IAuthenticationFlow> = [
            new CrossAuthenticationFlow(),
            new MigrationAuthenticationFlow(),
        ];

        for (let flow of listOfFlows) {
            if (!(await flow.start())) {
                break;
            }
        }
    };
}
